// import external dependencies
import 'jquery'

// Import everything from autoload
import './autoload/_bootstrap.js'
import 'flexslider'

//var google = require('google-maps');
//import google from 'google-maps';

//import GoogleMapsLoader from 'google-maps';

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())
;(function($) {
  $('.flexslider').flexslider({
    animation: 'slide',
  })
})(jQuery)
;(function($) {
  $('.elementor-widget-posts .elementor-post__excerpt p').append(' ...');

  $('article.elementor-grid-item.event').click(function() {
    //console.log(this.getAttribute('data-link'));
    document.location.href = this.getAttribute('data-link')
  })
  $('.ancre-liste-prix').click(function() {
    //console.log(this.getAttribute('data-link'));
    document.location.href = '#list-oeuvres'
  })

  $('#Actu').click(function() {
    //console.log(this.getAttribute('data-link'));
    document.location.href = 'actualite/'
  })

  var $firstPage = $(window).height() / 2,
    $backToTop = $('#Gotop')
  var $width = $(window).width()
  $(window).bind('scroll', function() {
    if ($(document).scrollTop() >= $firstPage && $width >= 676) {
      $backToTop.show()
    } else {
      $backToTop.hide()
    }

  })
})(jQuery)

;(function($) {
  $('#closenewsletter').click(function() {
    $('#opennewsletter').removeClass('hidden')
    $('#closenewsletter').addClass('hidden')
    $('#newsletter').addClass('hidden')
  })
  $('#opennewsletter').click(function() {
    $('#opennewsletter').addClass('hidden')
    $('#closenewsletter').removeClass('hidden')
    $('#newsletter').removeClass('hidden')
  })
})(jQuery)



// WEBPACK FOOTER //
// ./scripts/main.js